export const SECTIONS = [
  'currentMonth',
  'upcomingMonth',
  'scheduleOverview',
  'criticalIssues',
  'communityIssue',
];

export const NAMES = [
  'Current Month',
  'Upcoming Month',
  'Overview of Schedule Through Completion',
  'Critical issues',
  'Community issues',
];
